<template>
    <b-tabs 
        v-if="validarPermisoComponente('autogestionar-producto-empresa')"
        v-model="tabIndex">
        <b-tab
            v-if="!usuarioEmpresa"
            title="Empresas">
            <Asignacion :IdProducto.sync="IdProducto" v-if="tabIndex === 0"></Asignacion>
        </b-tab>
        <b-tab title="Ubicaciones">
            <Ubicaciones :IdProducto.sync="IdProducto" v-if="tabIndex === (usuarioEmpresa ? 0 : 1)"></Ubicaciones>
        </b-tab>
        <b-tab title="Campos Personaliz.">
            <CamposPersonalizados :IdProducto.sync="IdProducto" v-if="tabIndex === (usuarioEmpresa ? 1 : 2)"></CamposPersonalizados>
        </b-tab>    
        <b-tab title="Ubicaciones Cantidad">
            <UbicacionesCantidad :IdProducto.sync="IdProducto" v-if="tabIndex === (usuarioEmpresa ? 2 : 3)"></UbicacionesCantidad>
        </b-tab>
    </b-tabs>
</template>
<script>
import {mapState, mapActions} from 'vuex'
import Asignacion from './TablaAsignacion.vue'
import Ubicaciones from './Ubicaciones'
import CamposPersonalizados from './CamposPersonalizados.vue'
import UbicacionesCantidad from './UbicacionesCantidad.vue'
import { validarPermisoComponente } from "../../../plugins/acl";

export default {
    name:'TabsProductosEmpresa',
    props: ['IdProducto'],
    data: function(){
        return{
            tabIndex: 0,
        };
    },
    watch:{
        tabIndex(newValue) {
            switch (newValue) {
                case 0:
                    // this.traeAsignacion();
                    break;
                case 1:
                    break;
                case 2:
                    break;
                default:
                    break;
            }
        }
    },
    components:{
        Asignacion,
        Ubicaciones,
        CamposPersonalizados,
        UbicacionesCantidad,
    },
    methods:{
        validarPermisoComponente,
        async traeAsignacion(){
            await this.getInfoAsignacion(this.IdProducto);
        },
        async traeBasesAreas(){
            await this.getEmpresasAsig(this.IdProducto);
        },
        async traeCamposPersonalizados(){
          await this.getCamposPersonalizados(this.IdProducto);
        },
        ...mapActions('asignacionproductos',[
            'getInfoAsignacion',
            'getEmpresasAsig',
            'getCamposPersonalizados'
        ]),
    },
    computed: {
        ...mapState("autenticacion", ["usuarioEmpresa"]),
    }
}
</script>
